export default __webpack_public_path__ + "static/media/Keuringsfirma_logo_pos_RGB.eb944b1d.png";